import React from 'react';
import { chapters } from '../data/landing';
export function ChaptersSection() {
  return <section id="contenido" className="scroll-mt-16 bg-ink" data-id="element-47" data-mp="3a1jur0g6lsvu">
      <div className="mx-auto grid max-w-6xl gap-5 px-5 py-10 md:px-6 md:py-16 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16 lg:py-20" data-id="element-48" data-mp="3a460cujihybf">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-49" data-mp="3jzzc4bpepns5">
          <h2 className="font-display text-xl leading-tight text-cream md:text-3xl lg:text-4xl" data-id="element-50" data-mp="3jzhh1iehdflt">
            ¿Qué descubrirás dentro del libro?
          </h2>
          <p className="mt-2 max-w-sm font-serif text-base md:mt-4 leading-relaxed text-muted md:text-xl" data-id="element-51" data-mp="2rasfji9ij89j">
            Seis recorridos que conectan la mente, la percepción y los símbolos
            que han acompañado a la humanidad.
          </p>
        </div>

        <ol className="border-t border-line" data-id="element-52" data-mp="3137sg15yd6nk">
          {chapters.map(c => <li key={c.number} className="grid grid-cols-[2.75rem_1fr] gap-2 border-b border-line py-3.5 md:grid-cols-[4rem_1fr] md:gap-4 md:py-6" data-id="element-53" data-mp="23jwqgswfyr5z">
              <span className="font-display text-lg text-gold md:text-2xl" data-id="element-54" data-mp="a5y4sthmylcs">
                {c.number}
              </span>
              <div data-id="element-55" data-mp="59zcwvx3ml7m">
                <h3 className="font-display text-[15px] text-cream md:text-lg" data-id="element-56" data-mp="gmwva6hjmqh">
                  {c.title}
                </h3>
                <p className="mt-1 text-sm md:mt-2 leading-relaxed text-muted md:text-base" data-id="element-57" data-mp="3rm6708sufdxv">
                  {c.description}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}